"use client";

import { useEffect, useState } from "react";
import { fetchWrapper } from "@/helpers";

export const LEGAL_DOCS = ["termeni-si-conditii", "politica-de-confidentialitate", "politica-cookies"];
export const LEGAL_LOCALES = ["ro", "en", "fr", "de", "it"];

export default function LegalContent({ doc, locale, children }) {
	const [overrideHtml, setOverrideHtml] = useState(null);

	useEffect(() => {
		let active = true;
		setOverrideHtml(null);

		fetchWrapper
			.get(`/api/legal?doc=${doc}&locale=${locale}`)
			.then((res) => {
				if (active && res?.value) setOverrideHtml(res.value);
			})
			.catch(() => {});

		return () => {
			active = false;
		};
	}, [doc, locale]);

	if (!overrideHtml) return children;

	return (
		<>
			<style jsx global>{`
				.legal-override-content h1 {
					font-size: 2.4rem;
					font-weight: 700;
					color: #111;
					margin-bottom: 10px;
				}
				.legal-override-content h2 {
					font-size: 1.4rem;
					color: #111;
					margin-top: 40px;
					margin-bottom: 12px;
				}
				.legal-override-content h3 {
					font-size: 1.1rem;
					color: #222;
					margin-top: 25px;
					margin-bottom: 10px;
				}
				.legal-override-content p {
					line-height: 1.7;
					margin-bottom: 16px;
				}
				.legal-override-content ul,
				.legal-override-content ol {
					list-style: disc;
					margin-left: 25px;
					margin-bottom: 16px;
				}
				.legal-override-content a {
					color: #0077cc;
					text-decoration: none;
				}
				.legal-override-content a:hover {
					text-decoration: underline;
				}
				.legal-override-content hr {
					border: none;
					border-top: 1px solid #ddd;
					margin: 30px 0;
				}
				.legal-override-content table {
					width: 100%;
					border-collapse: collapse;
					font-size: 0.95rem;
					margin-bottom: 25px;
				}
				.legal-override-content th,
				.legal-override-content td {
					padding: 12px 10px;
					text-align: left;
					border-bottom: 1px solid #e5e5e5;
				}
				.legal-override-content th {
					background-color: #f2f2f2;
					color: #111;
					font-weight: 600;
				}
			`}</style>
			<div className='legal-override-content' dangerouslySetInnerHTML={{ __html: overrideHtml }} />
		</>
	);
}
